export default "__VITE_ASSET__AmnCBsPv__"